import { Quote } from "@/data/quotesInterface";

export async function getRandomQuote(): Promise<Quote> {
    const baseUrl = process.env.NEXT_PUBLIC_SITE_URL || 'http://localhost:3000';
    const apiUrl = `${baseUrl}/api/randomquote`;
    const response = await fetch(apiUrl);
    if (!response.ok) {
        throw new Error('Failed to fetch random quote');
    }
    const data = await response.json();
    return data;
}
export async function getFilteredQuotes(selectedCategories: string[], selectedAuthors: string[], term: string, page: number, random: boolean): Promise<{quotes: Quote[], totalQuotes: number}> {
    const baseUrl = process.env.NEXT_PUBLIC_SITE_URL || 'http://localhost:3000';
    const categoriesParam = selectedCategories.join(',');
    const authorsParam = selectedAuthors.join(',');
    const apiUrl = `${baseUrl}/api/filterquotes?categories=${encodeURIComponent(categoriesParam)}&authors=${encodeURIComponent(authorsParam)}&term=${encodeURIComponent(term)}&page=${page}&random=${random}`;
    const response = await fetch(apiUrl);
    if (!response.ok) {
        throw new Error('Failed to fetch filtered quotes');
    }
    const data = await response.json();
    return data;
}
export async function getAllCategories(): Promise<string[]> {
    const baseUrl = process.env.NEXT_PUBLIC_SITE_URL || 'http://localhost:3000';
    const apiUrl = `${baseUrl}/api/categories`;
    const response = await fetch(apiUrl);
    if (!response.ok) {
        throw new Error('Failed to fetch categories');
    }
    const data = await response.json();
    return data;
}
export async function getAllAuthors(): Promise<string[]> {
    const baseUrl = process.env.NEXT_PUBLIC_SITE_URL || 'http://localhost:3000';
    const apiUrl = `${baseUrl}/api/authors`;
    const response = await fetch(apiUrl);
    if (!response.ok) {
        throw new Error('Failed to fetch authors');
    }
    const data = await response.json();
    return data;
}